<template>
  <div id="app">
    <page-wrapper></page-wrapper>
  </div>
</template>

<script>
import PageWrapper from './components/pageWrapper'
export default {
  name: 'app',
  components: {
    PageWrapper
  },
  data() {
      return {
        // radio:'',
        // checked:true
      }
    },
  created() {

  },
  methods:{

	}
}
</script>

<style>

.el-button .el-button--primary {
  background-color:#00CED1;
  border-color:#00CED1;
}
.tabs .el-tabs{
  display: block;
}
.tabs .el-tabs .el-tabs__header .el-tabs__item.is-active{
  color: #00CED1;
}
.tabs .el-tabs .el-tabs__active-bar  {
  background-color: #00CED1; 
  height: 2px;
}
</style>
